/* eslint-disable import/prefer-default-export */
export const invoiceQueryKeys = {
  allInvoices: () => ["invoice", "all"],
  invoiceListing: (filters: any) => ["invoice", "list", filters],
  invoiceAuditListing: (id: string) => ["invoice-audit", "list", id],
  invoiceCommentsListing: (id: string) => ["invoice-comments", "list", id],
  shipmentInvoicesListing: (id: string) => ["shipment-invoices", "list", id],
  invoiceAttachmentDetails: (id: string) => ["invoice-attachment", "detail", id],
  invoiceAttachmentBucketList: (filters: any) => ["invoice-attachment-bucket", "list", filters],
  invoiceConfig: (id: string, filters?: any) => (filters ? ["invoice-config", id, filters] : ["invoice-config", id]),
  invoiceDraft: (id: string) => ["invoice-draft", id],
};
